import { SliderDrag as SliderDragCore } from '@studiometa/ui';

/**
 * Slider component
 */
export default class SliderDrag extends SliderDragCore {
  static config = {
    name: 'SliderDrag',
  };

  /**
   * Check if target is a 3D model
   * @param {object} props
   * @param {Event} props.event
   */
  onMousedown({ event }) {
    this.isModel = event.target.tagName.toLowerCase() === 'model-viewer';
  }

  /**
   *
   */
  onMouseup() {
    this.isModel = false;
  }

  /**
   * Check if two fingers touche the device
   * @param {object} props
   * @param {Event} props.event
   */
  onTouchstart({ event }) {
    this.isModel = event.target.tagName.toLowerCase() === 'model-viewer';
  }

  /**
   *
   */
  onTouchend() {
    this.isModel = false;
  }

  /**
   * Emit drag events.
   * @param {*} props Object
   * @returns {void}
   */
  dragged(props) {
    if (this.isModel) {
      return;
    }
    this.$emit(props.mode, props);
  }
}
